<template>
  <div class="layout_common">
    <div class="main_box">
      <div class="main_box_con">
        <div class="search_flex">
          <div class="search_left">
            <inputComp
              placeholder="客户名称"
              :hval="customerName"
              @blur="customerNameBlur"
            />
            <inputComp
              placeholder="订单编号"
              :hval="orderCode"
              @blur="orderCodeBlur"
            />
            <inputComp
              placeholder="设备序列号"
              :hval="serialNum"
              @blur="serialNumBlur"
            />
            <paramsDictNoForm
              placeholder="错误类型原因"
              :hval="reason"
              @change="reasonChange"
              :parentCode="101455"
            />
            <!-- 商家搜索 -->
            <merchant
              showRankBtn
              :hval="storeName"
              @storeNameChange="storeNameChange"
              @rankClick="isShow = true"
            />
            <btnGroup @search="search" @reset="reset" />
          </div>
        </div>
        <tableComp
          :data="tableData"
          :col-configs="theadName"
          :total="total"
          :currentPage="curPage"
          :pageSize="pageSize"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          v-loading="loading"
        >
          <el-table-column slot="customerName" label="客户名称/订单号">
            <template v-slot="scope">
              <div>{{ scope.row.customerName }}</div>
              <div>{{ scope.row.orderCode }}</div>
              <div></div>
            </template>
          </el-table-column>
          <el-table-column slot="num" label="下单数量/在租数量">
            <template v-slot="scope">
              <div>
                {{ scope.row.leaseQuantity || '-' }} /
                {{ scope.row.rentInQuantity || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column slot="rentDate" label="起租日期/到期日期">
            <template v-slot="scope">
              <div>
                {{ scope.row.rentStartDate? scope.row.rentStartDate.slice(0,10) : '-' }} /
                {{ scope.row.rentEndDate? scope.row.rentEndDate.slice(0,10) : '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column slot="leaseMode" label="租赁模式/租赁周期">
            <template v-slot="scope">
              <div>
                {{ scope.row.leaseMode || '-' }} /
                {{ scope.row.period || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column slot="operate" label="操作" fixed="right">
            <template v-slot="scope">
              <btnComp btnType="text" @click="edit(scope.row,'edit')" v-permission="'修改'">修改</btnComp>
            </template>
          </el-table-column>
        </tableComp>
      </div>
    </div>
    <!-- 商家发货排名 -->
    <rank :isShow="isShow" @close="isShow = false" @selectStore="selectStore" />
    <add :isShow="addShow" @close="close" :info="info" :dialogType="dialogType" />
  </div>
</template>
<script>
import merchant from '@/views/components/merchant'
import rank from '@/views/data-center/components/rank'
import paramsDictNoForm from '@/views/components/paramsDictNoForm'
import add from './add'
import { errorOrderList } from '@/api'
export default {
  components: {
    merchant,
    paramsDictNoForm,
    rank,
    add
  },
  data () {
    return {
      isShow: false,
      addShow: false,
      loading: false,
      curPage: 1,
      pageSize: 10,
      total: 0,
      dialogType: '', // 记录弹窗类型
      info: {},
      customerName: '',
      orderCode: '',
      serialNum: '',
      reason: '',
      storeName: '',
      storeId: '',
      tableData: [],
      theadName: [
        { slot: 'operate' },
        { prop: 'statusName', label: '处理状态' },
        { prop: 'orderStatusName', label: '订单状态' },
        { slot: 'customerName' },
        { prop: 'commodityName', label: '商品名称' },
        { prop: 'storeName', label: '商家' },
        { slot: 'num' },
        { slot: 'leaseMode' },
        { slot: 'rentDate' },
        { prop: 'reasonContent', label: '错误类型' },
        { prop: 'remark', label: '错误描述' },
        { prop: 'operator', label: '操作人' }

      ]
    }
  },
  computed: {
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      const params = {
        curPage: this.curPage,
        pageSize: this.pageSize,
        customerName: this.customerName,
        orderCode: this.orderCode,
        serialNum: this.serialNum,
        reason: this.reason,
        storeId: this.storeId
      }
      this.loading = true
      errorOrderList(params).then(res => {
        this.loading = false
        const { list, totalCount } = res.data
        this.tableData = list
        this.total = totalCount
      })
    },
    customerNameBlur (val) {
      this.customerName = val
    },
    orderCodeBlur (val) {
      this.orderCode = val
    },
    serialNumBlur (val) {
      this.serialNum = val
    },
    reasonChange (val) {
      this.reason = val.code
    },
    storeNameChange (val) {
      this.storeId = val.partnerId
      this.storeName = val.partnerName
    },
    // 选择的商家
    selectStore (val) {
      this.storeId = val.storeId
      this.storeName = val.storeName
    },
    // 修改弹窗
    edit (info, type) {
      this.dialogType = type
      this.addShow = true
      this.info = info
    },
    close () {
      this.addShow = false
      this.getList()
    },
    search () {
      this.curPage = 1
      this.getList()
    },
    reset () {
      // 重置后赋值初始值
      this.level = this.initLevel
      this.cityId = this.initCityId
      this.salesArea = this.initSalesArea

      this.customerName = ''
      this.orderCode = ''
      this.serialNum = ''
      this.reason = ''
      this.storeName = ''
      this.storeId = ''
      this.getList()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.curPage = val
      this.getList()
    }
  }
}
</script>
